<template>
    <iframe width="411" height="305" :src="video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</template>

<script>
export default {
    props: ['video']
}
</script>




// WEBPACK FOOTER //
// src/components/user/mensagens/layout/ContainerVideo.vue